import { render } from "./BoardDataCard.vue?vue&type=template&id=fd9d32b6&scoped=true"
import script from "./BoardDataCard.vue?vue&type=script&lang=js"
export * from "./BoardDataCard.vue?vue&type=script&lang=js"

import "./BoardDataCard.vue?vue&type=style&index=0&id=fd9d32b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9d32b6"],['__file',"src/components/h5/board/BoardDataCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd9d32b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd9d32b6', __exports__)) {
    api.reload('fd9d32b6', __exports__)
  }
  
  module.hot.accept("./BoardDataCard.vue?vue&type=template&id=fd9d32b6&scoped=true", () => {
    api.rerender('fd9d32b6', render)
  })

}


export default __exports__